export default {
  isEmpty(obj) {
    return obj === null || obj === undefined || obj === ''
  },
}
